import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/Tobias.jpg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  };
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Absenden');
  const [status, setStatus] = useState({});
  const [successModalOpen, setSuccessModalOpen] = useState(false);

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    });
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^[0-9+]*$/.test(value)) {
      onFormUpdate('phone', value);
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(formDetails.email)) {
    setStatus({ success: false, message: 'Bitte gib eine gültige E-Mail-Adresse ein.' });
    return;
  }

  const phoneRegex = /^(?:\+49|0)[1-9][0-9]{8,14}$/;
  if (!phoneRegex.test(formDetails.phone)) {
    setStatus({ success: false, message: 'Bitte gib eine gültige Handynummer ein.' });
    return;
  }

  setButtonText("Senden...");

  try {
    const response = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=utf-8" },
      body: JSON.stringify(formDetails),
    });

    const result = await response.json();
    setButtonText("Absenden");
    setFormDetails(formInitialDetails);

    if (response.ok) {
      setStatus({ success: true, message: result.message });
      setSuccessModalOpen(true);
    } else {
      setStatus({ success: false, message: result.message || 'Fehler beim Senden' });
    }
  } catch (error) {
    console.error("Fehler beim Senden:", error);
    setStatus({ success: false, message: 'Server nicht erreichbar oder Fehler beim Senden.' });
    setButtonText("Absenden");
  }
};


  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <div>
              <img src={contactImg} alt="Contact Us" />
            </div>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div>
                  <h2>Schreib mir</h2>
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input type="text" value={formDetails.firstName} placeholder="Vorname" onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input type="text" value={formDetails.lastName} placeholder="Nachname" onChange={(e) => onFormUpdate('lastName', e.target.value)} />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input type="email" value={formDetails.email} placeholder="E-Mail-Adresse" onChange={(e) => onFormUpdate('email', e.target.value)} />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input type="tel" value={formDetails.phone} placeholder="Handynummer" onChange={handlePhoneChange} />
                      </Col>
                      <Col size={12} className="px-1">
                        <textarea rows="6" value={formDetails.message} placeholder="Nachricht" onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                        <button type="submit"><span>{buttonText}</span></button>
                      </Col>
                      {
                        status.message &&
                        <Col>
                          <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                        </Col>
                      }
                    </Row>
                  </form>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

      {/* ✅ Erfolgspopup */}
      {successModalOpen && (
        <div className="popup-overlay">
          <div className="popup-modal">
            <h2>Danke!</h2>
            <p>Deine Nachricht wurde erfolgreich gesendet.</p>
            <button onClick={() => setSuccessModalOpen(false)}>Schließen</button>
          </div>
        </div>
      )}
    </section>
  );
};
